import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Reading({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2 -1.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M29.8202547 24.2766509c0-1.6681132 1.3524528-3.020566 3.0205661-3.020566.0442452 0 .0851886.010566.1287735.0125472l.7237736-7.7231132c-10.8592453-1.4475472-15.5116037 5.6237736-15.5116037 5.6237736-6.2306604-7.1650944-15.42575477-5.4421699-15.42575477-5.4421699l.79575472 7.5765095c.15518868-.024434.31103774-.0475472.47349057-.0475472 1.6681132 0 3.02056603 1.3524528 3.02056603 3.020566 0 1.6146227-1.27122641 2.9228302-2.86603773 3.004717l.6385849 6.0781132c8.55915098-1.4013207 13.40632078 2.5160378 13.40632078 2.5160378 5.8636902-4.1662904 13.6123585-2.5160378 13.6123585-2.5160378l.5718868-6.105849c-1.4614151-.2119812-2.5886793-1.4567925-2.5886793-2.9769812z" />
        <path d="M4.02525472 21.2558868c-.16245283 0-.31830189.0231132-.47349057.0475472-1.44160377.2284905-2.54707547 1.4666981-2.54707547 2.9730188 0 1.6681132 1.35245283 3.0199057 3.02056604 3.0199057.05283019 0 .10235849-.0125472.1545283-.0151887 1.59481132-.0818868 2.86603773-1.389434 2.86603773-3.004717 0-1.6681132-1.35245283-3.020566-3.02056603-3.020566z" />
        <path d="M32.9695943 21.2688302c-.0435849-.0019811-.0845283-.0132076-.1287735-.0132076-1.6681133 0-3.0205661 1.3524529-3.0205661 3.0212265 0 1.5195283 1.1266038 2.765 2.5886793 2.9769811.1419811.0204717.2839622.0429245.4318868.0429245 1.6681132 0 3.0199056-1.3524528 3.0199056-3.0199056 0-1.623868-1.2844339-2.9393397-2.8911321-3.0080189zM24.1109623 7.65178302c0 3.37783018-2.7379246 6.11641508-6.1164151 6.11641508-3.3771698 0-6.1157547-2.7385849-6.1157547-6.11641508 0-3.37783019 2.7385849-6.1164151 6.1157547-6.1164151 3.3784905 0 6.1164151 2.73858491 6.1164151 6.1164151zM18.2804245 19.1690283v16.7062264" />
      </g>
    </svg>
  )
}

Reading.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
